//
// Imports
//

import { Prisma } from "@prisma/client";
import { z } from "zod";

//
// Schemas
//

type Profile = Pick<Prisma.ProfileGetPayload<null>, keyof Prisma.ProfileFieldRefs>;

export const IdSchema: z.ZodType<Profile["id"], z.ZodTypeDef, any> = z
	.coerce
	.number()
	.int()
	.positive();

export const AboutSyntaxSchema: z.ZodType<Profile["aboutSyntax"], z.ZodTypeDef, any> = z
	.coerce
	.number()
	.int()
	.min(0)
	.max(1);

export const AboutTextSchema: z.ZodType<Profile["aboutText"], z.ZodTypeDef, any> = z
	.string()
	.trim()
	.transform((value) => value == "" ? null : value);

export const ColorSchema: z.ZodType<Profile["color"], z.ZodTypeDef, any> = z.union(
	[
		z.string().trim().regex(/^#[0-9a-fA-F]{6}$/),

		z.literal("").transform(() => null),
	]);